/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

/* tslint:disable:max-classes-per-file */
// tslint:disable:max-classes-per-file
import { Action } from '@ngrx/store';

export const LOAD_USER_NEW_VIDEOS = '[User New Videos] Load user new videos';
export const LOAD_USER_NEW_VIDEOS_FAIL = '[User New Videos] Load user new videos fail';
export const LOAD_USER_NEW_VIDEOS_SUCCESS = '[User New Videos] Load user new videos success';
export const DELETE_USER_NEW_VIDEOS = '[User New Videos] Delete user new videos';
export const DELETE_USER_NEW_VIDEOS_SUCCESS = '[User New Videos] Delete user new videos success';
export const ADD_USER_NEW_VIDEOS = '[User New Videos] Add user new videos';
export const ADD_USER_NEW_VIDEOS_SUCCESS = '[User New Videos] Add user new videos success';

export class LoadUserNewVideos implements Action {
  readonly type = LOAD_USER_NEW_VIDEOS;

  constructor(public payload: any) {}
}

export class LoadUserNewVideosFail implements Action {
  readonly type = LOAD_USER_NEW_VIDEOS_FAIL;

  constructor(public payload: any) {}
}

export class LoadUserNewVideosSuccess implements Action {
  readonly type = LOAD_USER_NEW_VIDEOS_SUCCESS;

  constructor(public payload: any) {}
}

export class DeleteUserNewVideos implements Action {
  readonly type = DELETE_USER_NEW_VIDEOS;

  constructor(public payload: any) {}
}

export class DeleteUserNewVideosSuccess implements Action {
  readonly type = DELETE_USER_NEW_VIDEOS_SUCCESS;

  constructor(public payload: any) {}
}

export class AddUserNewVideos implements Action {
  readonly type = ADD_USER_NEW_VIDEOS;

  constructor(public payload: any) {}
}

export class AddUserNewVideosSuccess implements Action {
  readonly type = ADD_USER_NEW_VIDEOS_SUCCESS;

  constructor(public payload: any) {}
}

export type UserNewVideosAction =
  | LoadUserNewVideos
  | LoadUserNewVideosFail
  | LoadUserNewVideosSuccess
  | DeleteUserNewVideos
  | DeleteUserNewVideosSuccess
  | AddUserNewVideos
  | AddUserNewVideosSuccess;
